import React, {Component} from 'react';
import NavBar from '../navbar/NavBar';
import Footer from '../footer/Footer'
import {Route, Switch} from 'react-router-dom';
import './MainLayout.scss';
import {RouteConstants} from "../route/services/RouteConstants";
import PrivateRoute from "../route/PrivateRoute";
import AuthError from "../../pages/auth-error/AuthError";
import Login from "../../pages/login/Login";
import Logout from "../../pages/logout/Logout";
import AuthCallbackPage from "../../pages/auth-callback-page/AuthCallbackPage";
import ForgotPasswordPage from "../../pages/forgot-password/ForgotPassword";
import ForgotPasswordSentPage from "../../pages/forgot-password/ForgotPasswordSent";
import AddLoadConfiguration from "../app-initialization/AddLoadConfiguration";
import PasswordReset from "../../pages/forgot-password/PasswordReset";
import PasswordResetErrorPage from "../../pages/forgot-password/PasswordResetErrorPage";
import OtcAuthCallbackPage from "../../pages/auth-callback-page/OtcAuthCallbackPage";
import PassUserName from "../../pages/pass-user-name/pass-user-name";
import ForgotUserName from "../../pages/forgot-user-name/ForgotUserName";
import ForgotUserNameSent from "../../pages/forgot-user-name/ForgotUserNameSent";
import IncompleteRegistration from "../../pages/incomplete-registration/IncompleteRegistration";
import CompleteRegistrationRequestEmailSent from "../../pages/incomplete-registration/CompleteRegistrationRequestEmailSent";
import Registration from "../../pages/registration/Registration";
import StudentWelcomePage from "../../pages/student-password-reset/WelcomePage"
import StudentUnavailable from "../../pages/student-password-reset/Unavailable"
import StudentPasswordReset from "../../pages/student-password-reset/PasswordForceReset"
import StudentAccountLocked from "../../pages/student-password-reset/Locked"

class MainLayout extends Component {

  constructor(props) {
    super(props);
    this.props = props;
  }

  render() {
    return (
        <div className="hrb-main-layout">
          <Route path="/" render={props => <NavBar {...props}  />}/>
          <div className="hrb-container">
            <Switch>
              <Route exact path={RouteConstants.AUTH_CALLBACK} render={(props) => (<AuthCallbackPage {...props}/>)} />
              <Route path={RouteConstants.LOGIN} component={Login} />
              <Route path={RouteConstants.LOGOUT} component={Logout} />
              <Route exact path={RouteConstants.OTC_CALLBACK} render={(props) => (<OtcAuthCallbackPage {...props}/>)} />
              <Route path={RouteConstants.AUTH_ERROR} component={AuthError} />
              <Route path={RouteConstants.FORGOT_PASSWORD_SENT} component={ForgotPasswordSentPage} />
              <Route path={RouteConstants.FORGOT_PASSWORD} component={ForgotPasswordPage} />
              <Route path={RouteConstants.INCOMPLETE_REGISTRATION} component={IncompleteRegistration} />
              <Route path={RouteConstants.COMPLETE_REGISTRATION_REQUEST_EMAIL_SENT} component={CompleteRegistrationRequestEmailSent} />
              <Route path={RouteConstants.PASSWORD_RESET_ERROR} component={PasswordResetErrorPage} />
              <Route path={RouteConstants.PASSWORD_RESET} component={PasswordReset} />
              <Route path={RouteConstants.PASS_USER_NAME} component={PassUserName} />
              <Route path={RouteConstants.FORGOT_USERNAME_SENT} component={ForgotUserNameSent} />
              <Route path={RouteConstants.FORGOT_USERNAME} component={ForgotUserName} />
              {/*Default to Dashboard, if unauthenticated, PrivateRoute with force a login*/}
              <Route path={RouteConstants.REGISTER} component={Registration} />
              <Route path={RouteConstants.STUDENT_WELCOME} component={StudentWelcomePage} />
              <Route path={RouteConstants.STUDENT_ACCOUNT_NOT_SETUP} component={StudentUnavailable} />
              <Route path={RouteConstants.STUDENT_PASSWORD_FORCE_RESET} component={StudentPasswordReset} />
              <Route path={RouteConstants.STUDENT_ACCOUNT_LOCKED} component={StudentAccountLocked} />
              <PrivateRoute path="*" component={StudentWelcomePage} />
            </Switch>
            <Route path="/" render={props => <Footer {...props} />} />
          </div>
        </div>
    );
  }
}

export default AddLoadConfiguration(MainLayout);
